"use strict";
/// <reference lib="DOM" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadlyEmbededReviewClient = void 0;
var axios_1 = __importDefault(require("axios"));
var BroadlyEmbededReviewClient = /** @class */ (function () {
    function BroadlyEmbededReviewClient(parser) {
        this.parser = parser;
        this.broadlyReviewPromises = new Map();
        this.client = axios_1.default.create({ baseURL: "https://embed.broadly.com" });
    }
    BroadlyEmbededReviewClient.prototype.getBroadlyEmbedReviews = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var reviews, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Array).from;
                        return [4 /*yield*/, this.getBroadlyEmbedReviewsPromiseCached(params.broadlyLocationId)];
                    case 1:
                        reviews = _b.apply(_a, [(_c.sent()).reviews]);
                        return [2 /*return*/, reviews.slice((params.page - 1) * params.pageSize, params.page * params.pageSize)];
                }
            });
        });
    };
    BroadlyEmbededReviewClient.prototype.getBroadlyEmbedReviewCount = function (broadlyLocationId) {
        return __awaiter(this, void 0, void 0, function () {
            var reviewPull;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBroadlyEmbedReviewsPromiseCached(broadlyLocationId)];
                    case 1:
                        reviewPull = _a.sent();
                        return [2 /*return*/, {
                                real: reviewPull.reviews.length,
                                display: reviewPull.allReviewCount
                            }];
                }
            });
        });
    };
    BroadlyEmbededReviewClient.prototype.getBroadlyEmbedFranchiseRating = function (broadlyLocationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBroadlyEmbedReviewsPromiseCached(broadlyLocationId)];
                    case 1: return [2 /*return*/, (_a.sent()).franchiseRating];
                }
            });
        });
    };
    BroadlyEmbededReviewClient.prototype.getBroadlyEmbedReviewsPromiseCached = function (broadlyLocationId) {
        return __awaiter(this, void 0, void 0, function () {
            var reviewPromise;
            return __generator(this, function (_a) {
                reviewPromise = this.broadlyReviewPromises.get(broadlyLocationId);
                if (!reviewPromise) {
                    reviewPromise = this.pullBroadlyEmbedReviews(broadlyLocationId);
                    this.broadlyReviewPromises.set(broadlyLocationId, reviewPromise);
                }
                return [2 /*return*/, reviewPromise];
            });
        });
    };
    BroadlyEmbededReviewClient.prototype.pullBroadlyEmbedReviews = function (broadlyLocationId) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var htmlResponse, document, body, reviewElements, franchiseRating, allReviewCount, reviews;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.client.get("/" + broadlyLocationId + "/reviews")];
                    case 1:
                        htmlResponse = _e.sent();
                        return [4 /*yield*/, this.parser(htmlResponse.data)];
                    case 2:
                        document = _e.sent();
                        body = document.body;
                        reviewElements = Array.from(body.querySelectorAll(".broadly-reviews .broadly-review"));
                        franchiseRating = parseFloat((_b = (_a = body.querySelector(".broadly-review-aggregate meta[itemprop=\"ratingValue\"]")) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : "");
                        allReviewCount = parseFloat(((_d = (_c = body.querySelector(".broadly-review-aggregate > span:last-child")) === null || _c === void 0 ? void 0 : _c.innerText) !== null && _d !== void 0 ? _d : "").replace(/\D/g, ''));
                        reviews = reviewElements.map(function (el) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                            var npsRating = parseFloat((_b = (_a = el.querySelector("meta[itemprop=\"ratingValue\"]")) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : "5") * 2;
                            var reviewNetPromoterTypeId = 0;
                            if (npsRating >= 9)
                                reviewNetPromoterTypeId = 1;
                            if (npsRating <= 6)
                                reviewNetPromoterTypeId = -1;
                            return {
                                type: "embed",
                                reviewId: el.id.replace("review-", ""),
                                isViewable: true,
                                npsRecommendationLikelihood: npsRating,
                                reviewNetPromoterTypeId: reviewNetPromoterTypeId,
                                comments: (_c = el.querySelector(".broadly-review-body")) === null || _c === void 0 ? void 0 : _c.innerHTML,
                                completedAt: (_d = el.querySelector("time")) === null || _d === void 0 ? void 0 : _d.dateTime,
                                reviewerImageUrl: (_e = el.querySelector(".broadly-review-avatar img")) === null || _e === void 0 ? void 0 : _e.src,
                                publicReviewerName: (_f = el.querySelector(".broadly-review-author")) === null || _f === void 0 ? void 0 : _f.innerText,
                                sourceName: (_g = el.querySelector(".broadly-review-via img")) === null || _g === void 0 ? void 0 : _g.alt,
                                publicResponse: (_h = el.querySelector(".broadly-response-body")) === null || _h === void 0 ? void 0 : _h.innerHTML,
                                publicResponseAuthor: (_j = el.querySelector(".broadly-response-author")) === null || _j === void 0 ? void 0 : _j.innerHTML
                            };
                        });
                        return [2 /*return*/, {
                                reviews: reviews,
                                franchiseRating: franchiseRating,
                                allReviewCount: allReviewCount
                            }];
                }
            });
        });
    };
    return BroadlyEmbededReviewClient;
}());
exports.BroadlyEmbededReviewClient = BroadlyEmbededReviewClient;
